import { folderSchemas } from "@redotech/redo-model/views/folders";
import { viewWithIdSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";
export const saveViewsAndFolders = {
  name: "saveViewsAndFolders" as const,
  input: z.object({
    folders: z.array(folderSchemas["fulfillment-groups"]),
    views: z.array(viewWithIdSchemas["fulfillment-groups"]),
  }),
  output: zNull(),
};
